import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { DebugService } from 'app/components/debugger/debug.service';
import { ModalService } from '../modal/modal.service';

@Component({
  selector: 'app-debug-button',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule],
  template: `
    <button mat-icon-button 
            class="fixed bottom-5 end-5 z-50 bg-white/90 shadow-md hover:bg-white" 
            (click)="showDebugLogs()" 
            [disabled]="isDebugModalOpen()"
            *ngIf="isDebugEnabled()">
      <mat-icon>bug_report</mat-icon>
    </button>
  `,
})
export class DebugButtonComponent {
  constructor(
    private _debug: DebugService,
    private _modal: ModalService
  ) {}

  showDebugLogs(): void {
    this._debug.showLogs();
  }

  isDebugEnabled(): boolean {
    return this._debug.isEnabled();
  }

  isDebugModalOpen(): boolean {
    return this._modal.isModalTypeOpen('debug-logs');
  }
} 